import { render } from "./SetPatientAddress.vue?vue&type=template&id=515038d3"
import script from "./SetPatientAddress.vue?vue&type=script&lang=js"
export * from "./SetPatientAddress.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__